type QuoteLikeType = { quotes: string | number; timesQuotes: string | number }

export const getRentabilityText = <T extends QuoteLikeType>(obj: T) =>
  `${obj.quotes} cuotas - ${obj.timesQuotes} días`
